import FlightDetailPriceSummary from "../../components/composite/flightDetailsCard/FlightDetailPriceSummary";
import FlightDetailMainCard from "../../components/composite/flightDetailsCard/FlightDetailMainCard";
import Header from "../../sharedScreens/Header";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";
import MuiButton from "../../components/basicComponent/MuiButton";
import React, { act, useEffect, useState } from "react";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";
import { getIn, useFormik } from "formik";
import FlightSeatInfo from "../../components/composite/flightDetailsCard/FlightSeatInfo";
import FlightPromoCard from "../../components/composite/flightDetailsCard/FlightPromoCard";
import dayjs from "dayjs";
import FreeCancellationCard from "../../components/composite/flightDetailsCard/FreeCancellationCard";
import PaymentCard from "../../components/composite/flightDetailsCard/PaymentCard";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { childrenTitle, titleList } from "../../constants/constant";
import { UtilService } from "../../services/shared/UtilService";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  calculateCommission,
  createSSRDetails,
  formatDate,
  generateRandomInteger,
  hasSufficientBalance,
  injectSSRDetails,
  injectSSRDetailsIntoSegments,
} from "../../constants/helper";
import { msgTypes } from "../../constants/msgTypes";
import { getTravelersValidationSchema } from "../../validations/Schema";
import { FlightServices } from "../../services/FlightServices/FlightServices";
import { useGlobalState } from "../../services/context/AuthContext";
import InsufficientBalanceModal from "../../components/composite/flightDetailsCard/InsufficientBalanceModal";
import { PaymentModeCard } from "../../components/composite/PaymentModeCard";
import { FormValues, PGRes, TravelerData } from "../../constants/types";
import { CoorporateType } from "../../constants/enum";
import Swal from "sweetalert2";
import { useAlert } from "../../services/customHooks/useAlert";
import { Checkbox, IconButton } from "@mui/material";
import Notifier from "../../components/basicComponent/Notifier";
import FlightSearch from "./FlightSearch";
import PhoneInput from "react-phone-input-2";
import { useFlightSearch } from "../../services/context/FlightSearchContext";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";

const steps = [" Review", "Travellers ", " Payment"];

const FlightDetail = () => {
  const { showAlert } = useAlert();
  const storedFlightSearch = localStorage.getItem("flight_recent_search");
  const storedSearch = JSON.parse(storedFlightSearch || "{}");
  const { userInfo, setUserInfo } = useGlobalState();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedSSR, setSelectedSSR] = useState<any[]>([]);
  const { originCode, destinationCode, fromDate, toDate } = useFlightSearch();
  // const ruleId = location?.state?.ruleId;
  const [ruleId, setRuleId] = useState(location?.state?.ruleId);
  useEffect(() => {
    getCountryCode();
  }, []);
  const [showInsufficientModal, setShowInsufficientModal] = useState(false);
  const [addonJourneys, setAddonJourneys] = useState<any[]>([]);
  const [activeJourneyIndex, setActiveJourneyIndex] = useState(0);
  const [isSeatMapLoading, setIsSeatMapLoading] = useState(false);
  const [selectedSeatsByJourney, setSelectedSeatsByJourney] = useState<{
    [journeyIndex: number]: {
      [legIndex: number]: any[];
    };
  }>({});
  const [isCheckBoxChecked, setIsCheckBoxChecked] = useState<boolean>(false);
  const [showNotifier, setShowNotifier] = useState<boolean>(false);
  const [isTravellerDetailFilled, setIsTravellerDetailFilled] = useState(false);
  const [countryCode, setCountryCode] = useState([]);
  const [countryName, setCountryName] = useState([]);
  const [nationality, setNationality] = useState([]);
  const [meals, setMeals] = useState<any[]>([]);
  const [baggage, setBaggage] = useState<any[]>([]);
  const [otherCharges, setOtherCharges] = useState<any>();
  const [seatMapData, setSeatMapData] = useState<[]>([]);
  const [ewtsOffer, setEwtsOffer] = useState(0);
  const [appliedCouponCode, setAppliedCouponCode] = useState("");

  const handleCouponApply = (amount: number, code: string) => {
    setEwtsOffer(amount);
    setAppliedCouponCode(code);
  };
  const oneWayData = location?.state?.outBoundData?.Bonds?.[0]?.Legs; //oneway
  const flightInboundDataforRoundTrip =
    location?.state?.inBoundData?.Bonds?.[0]?.Legs;

  const flightOutboundDataforRoundTrip =
    location?.state?.outBoundData?.Bonds?.[0]?.Legs;
  const flightRoundTripDataForInternationalOutBound =
    location?.state?.outBoundData?.Bonds?.[0]?.Legs;
  const flightRoundTripDataForInternationalInBound =
    location?.state?.outBoundData?.Bonds?.[1]?.Legs;
  const refundable =
    location?.state?.outBoundData?.Fare?.PaxFares?.[0]?.Refundable;
  const isInternationalFlight = location?.state?.outBoundData?.IsInternational;
  const fareRule = location?.state?.outBoundData?.FareRule;
  const isInbound = location?.state?.outBoundData?.BondType === "InBound";
  const travellersDetail = location?.state?.travellersDetail;
  const commissionAmount = location.state.commission;
  const traceId: string = location?.state?.traceId;
  const grandTotal =
    travellersDetail?.totalFare +
    (otherCharges?.grandTotal ?? 0) -
    (!!ewtsOffer ? ewtsOffer : 0);

  const emptyTraveler: TravelerData = {
    DOB: "",
    LastName: "",
    Title: "",
    MiddleName: "",
    Gender: "",
    EmailAddress: "",
    FrequentFlierNumber: "",
    FirstName: "",
    PassportExpiryDate: "",
    PassportNo: "",
    MobileNumber: "",
    isActive: true,
    isSelected: false,
    showPassport: true,
    showMealPreference: false,
    MealPreference: "",
    Airline: "",
    nationality: "",
    countryName: "",
    isInternational: isInternationalFlight,
  };
  const defaultInitialValues: FormValues = {
    adultTravellers: [{ ...emptyTraveler }],
    ChildTraveller: [{ ...emptyTraveler }],
    InfantTraveller: [{ ...emptyTraveler }],
    email: "",
    mobileNum: "",
    countryCode: "",
  };

  const STORAGE_KEY = "travellerFormValues";

  function loadFromStorage(): FormValues {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        return JSON.parse(saved) as FormValues;
      }
    } catch (e) {
      console.error("Failed to load form values from storage", e);
    }
    return defaultInitialValues;
  }

  function saveToStorage(values: FormValues) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(values));
    } catch (e) {
      console.error("Failed to save form values to storage", e);
    }
  }

  const formik = useFormik<FormValues>({
    initialValues: loadFromStorage(),
    validationSchema: getTravelersValidationSchema(
      travellersDetail?.adultCount,
      travellersDetail?.childrenCount,
      travellersDetail?.infantCount
    ),
    enableReinitialize: true,
    onSubmit(values) {
      checkIsSeatAvailble();
      setIsTravellerDetailFilled(true);
    },
  });

  // Save to localStorage whenever values change
  useEffect(() => {
    saveToStorage(formik.values);
  }, [formik.values]);

  // Functions to handle array operations for adult travelers
  const addAdultTraveller = () => {
    formik.setFieldValue("adultTravellers", [
      ...formik.values.adultTravellers,
      { ...emptyTraveler, isActive: true },
    ]);
  };
  const addChildTraveller = () => {
    formik.setFieldValue("ChildTraveller", [
      ...formik.values.ChildTraveller,
      { ...emptyTraveler, isActive: true },
    ]);
  };
  const addInfantTraveller = () => {
    formik.setFieldValue("InfantTraveller", [
      ...formik.values.InfantTraveller,
      { ...emptyTraveler, isActive: true },
    ]);
  };
  const removeAdultTraveller = (index: number) => {
    const newTravellers = [...formik.values.adultTravellers];
    newTravellers.splice(index, 1);
    formik.setFieldValue("adultTravellers", newTravellers);
  };
  const removeChildTraveller = (index: number) => {
    const newTravellers = [...formik.values.ChildTraveller];
    newTravellers.splice(index, 1);
    formik.setFieldValue("ChildTraveller", newTravellers);
  };
  const removeInfantTraveller = (index: number) => {
    const newTravellers = [...formik.values.InfantTraveller];
    newTravellers.splice(index, 1);
    formik.setFieldValue("InfantTraveller", newTravellers);
  };
  const toggleTravellerActive = (index: number) => {
    const newState = [...formik.values.adultTravellers];
    newState[index] = {
      ...newState[index],
      isActive: !newState[index].isActive,
    };
    formik.setFieldValue("adultTravellers", newState);
  };
  const toggleTravellerActiveForChild = (index: number) => {
    const newState = [...formik.values.ChildTraveller];
    newState[index] = {
      ...newState[index],
      isActive: !newState[index].isActive,
    };
    formik.setFieldValue("ChildTraveller", newState);
  };
  const toggleTravellerActiveForInfant = (index: number) => {
    const newState = [...formik.values.InfantTraveller];
    newState[index] = {
      ...newState[index],
      isActive: !newState[index].isActive,
    };
    formik.setFieldValue("InfantTraveller", newState);
  };
  const togglePassportInfo = (index: number) => {
    const newState = [...formik.values.adultTravellers];
    newState[index] = {
      ...newState[index],
      showPassport: !newState[index].showPassport,
    };
    formik.setFieldValue("adultTravellers", newState);
  };
  const togglePassportInfoForChild = (index: number) => {
    const newState = [...formik.values.ChildTraveller];
    newState[index] = {
      ...newState[index],
      showPassport: !newState[index].showPassport,
    };
    formik.setFieldValue("ChildTraveller", newState);
  };
  const togglePassportInfoForInfant = (index: number) => {
    const newState = [...formik.values.InfantTraveller];
    newState[index] = {
      ...newState[index],
      showPassport: !newState[index].showPassport,
    };
    formik.setFieldValue("InfantTraveller", newState);
  };
  const toggleMealPreference = (index: number) => {
    const newState = [...formik.values.adultTravellers];
    newState[index] = {
      ...newState[index],
      showMealPreference: !newState[index].showMealPreference,
    };
    formik.setFieldValue("adultTravellers", newState);
  };

  // mui-steper
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState<{
    [k: number]: boolean;
  }>({});

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  useEffect(() => {
    if (!!addonJourneys) {
      setIsSeatMapLoading(true);
      fetchAddOnServices(addonJourneys?.[activeJourneyIndex]?.Segments);
    }
  }, [activeJourneyIndex, addonJourneys]);
  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };
  const flightDetail = location?.state?.commissionValue;
  localStorage.setItem(
    "commissionValue",
    JSON.stringify(location?.state?.commissionValue)
  );

  const commissionType = location?.state?.commissionType;
  const commissionPercentage = location?.state?.commissionPercentage;
  const tripType = !!location?.state?.outBoundData ? 0 : 1;
  const flightSearchDetailOneway = [
    {
      BeginDate: formatDate(new Date(storedSearch?.fromDate ?? "")),
      Origin: storedSearch?.originCode,
      Destination: storedSearch?.destinationCode,
    },
  ];
  const flightSearchForRoundTrip = [
    {
      BeginDate: formatDate(new Date(storedSearch?.fromDate ?? "")),
      Origin: storedSearch?.originCode,
      Destination: storedSearch?.destinationCode,
    },
    {
      BeginDate: formatDate(new Date(storedSearch?.toDate ?? "")),
      Origin: storedSearch?.destinationCode,
      Destination: storedSearch?.originCode,
    },
  ];
  const flightSearchDetail =
    tripType === 0 ? flightSearchDetailOneway : flightSearchForRoundTrip;
  // useEffect(() => {
  //   if (isTravellerDetailFilled) {

  //     checkIsSeatAvailble()
  //   }
  // },[selectedSSR])
  const checkIsSeatAvailble = async () => {
    const onewayPaylod = {
      FlightAvailabilityRQ: {
        TripType: 0,

        FaresIndicatior: [location?.state?.outBoundData?.FareIndicator],
        TraceId: traceId,
        Adults: travellersDetail?.adultCount,
        Childs: travellersDetail?.childrenCount,
        Infants: travellersDetail?.infantCount,
        SaveSessionStatus: true,
        FlightSearchDetails: flightSearchDetailOneway,
      },
      Segment: [location?.state?.outBoundData],
    };

    const payloadRT = {
      FlightAvailabilityRQ: {
        TripType: 1,

        Adults: travellersDetail?.adultCount,
        Childs: travellersDetail?.childrenCount,
        Infants: travellersDetail?.infantCount,
        SaveSessionStatus: true,
        FaresIndicatior: [
          location?.state?.outBoundData?.FareIndicator,
          location?.state?.inBoundData?.FareIndicator,
        ],
        TraceId: traceId,
        FlightSearchDetails: flightSearchForRoundTrip,
      },
      Segment: [
        { ...location?.state?.outBoundData },
        { ...location?.state?.inBoundData },
      ],
    };

    const payloadINTL = {
      FlightAvailabilityRQ: {
        TripType: 0,

        Adults: travellersDetail?.adultCount,
        Childs: travellersDetail?.childrenCount,
        Infants: travellersDetail?.infantCount,
        SaveSessionStatus: true,
        FaresIndicatior: [location?.state?.outBoundData?.FareIndicator],
        TraceId: traceId,
        FlightSearchDetails: flightSearchDetailOneway,
      },
      Segment: [
        {
          ...location?.state?.outBoundData,
          Bonds: [location?.state?.outBoundData?.Bonds?.[0]],
        },
      ],
    };
    const payloadINTLFORRoundTrip = {
      FlightAvailabilityRQ: {
        TripType: 1, // 1 = round trip

        Adults: travellersDetail?.adultCount || 0,
        Childs: travellersDetail?.childrenCount || 0,
        Infants: travellersDetail?.infantCount || 0,
        SaveSessionStatus: true,
        FaresIndicatior: [
          location?.state?.outBoundData?.FareIndicator,
          location?.state?.inBoundData?.FareIndicator,
        ],
        TraceId: traceId,
        FlightSearchDetails: flightSearchForRoundTrip,
      },
      Segment: [
        {
          ...location?.state?.outBoundData,
          Bonds: [
            location?.state?.outBoundData?.Bonds?.[0],
            location?.state?.outBoundData?.Bonds?.[1],
          ],
        },
      ],
    };

    const payload = !!location.state?.inBoundData ? payloadRT : onewayPaylod;
    const intlPayload =
      !!location.state?.inBoundData && !!location.state?.outBoundData
        ? payloadINTLFORRoundTrip
        : payloadINTL;
    const mainPayload = !isInternationalFlight ? payload : intlPayload;
    try {
      const res = await FlightServices.checkAirRePriceRQ(mainPayload);
      // fetchAddOnServices(res?.Journeys?.[0]?.Segments);
      if (res?.data?.Errors !== null) {
        const err = res?.data?.Errors;
        //need a popup to showw flight sold out
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err?.Description ?? "Something went wrong. Please try again.",
          confirmButtonText: "OK",
          confirmButtonColor: "#d33",
        }).then(() => {
          navigate("/flightlist");
        });
      } else {
        setAddonJourneys(res?.data?.Journeys);
        localStorage.setItem(
          "bookingSegment",
          JSON.stringify(res?.data?.Journeys)
        );
        setActiveStep(1);
      }
    } catch (error: any) {
      showAlert({
        title: "Error",
        text: error.message || "Something went wrong. Please try again.",
        icon: "error",
      });
      console.log("error getting while fetching data", error);
    }
  };

  const fetchAddOnServices = async (segment: []) => {
    const onewayPaylod = {
      TraceID: traceId,
      AdultCount: travellersDetail?.adultCount,
      ChildCount: travellersDetail?.childrenCount,
      InfantCount: travellersDetail?.infantCount,
      Segments: segment,
    };

    const payloadRT = {
      AdultCount: travellersDetail?.adultCount,
      ChildCount: travellersDetail?.childrenCount,
      InfantCount: travellersDetail?.infantCount,
      TraceID: traceId,
      Segments: segment,
    };

    const payloadINTL = {
      AdultCount: travellersDetail?.adultCount,
      ChildCount: travellersDetail?.childrenCount,
      InfantCount: travellersDetail?.infantCount,
      TraceID: traceId,
      Segments: segment,
    };
    const payload = !!location.state?.inBoundData ? payloadRT : onewayPaylod;
    const mainPayload = !isInternationalFlight ? payload : payloadINTL;
    try {
      const response = await FlightServices.getAddonServices(mainPayload);
      if (response?.data?.error === null) {
        setSeatMapData(response?.data?.Seats);
        separateSSRByType(response?.data?.SSRs?.[0]?.lstSSRDetails);
        setIsSeatMapLoading(false);
      } else if (!!response?.data?.error) {
        showAlert({
          title: "Error",
          text: response?.data?.error?.Description || "Failed to fetch data",
          icon: "error",
        });
      }
    } catch (error: any) {
      showAlert({
        title: "Error",
        text: error?.message || "Failed to fetch data",
        icon: "error",
      });
      console.log("error while fetching add on services", error);
    }
  };
  const getCountryCode = async () => {
    try {
      const res = await UtilService.getCountryCode();

      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        const arr = res?.data?.map((i: { phonecode: any }) => ({
          label: i?.phonecode,
          value: i?.phonecode,
        }));
        const nationality = res?.data?.map((i: { nationality: any }) => ({
          label: i?.nationality,
          value: i?.nationality,
        }));
        const countryName = res?.data?.map((i: { countryName: any }) => ({
          label: i?.countryName,
          value: i?.countryName,
        }));

        setCountryCode(arr);
        setCountryName(countryName);
        setNationality(nationality);
      }
    } catch (error) {
      console.log("error while fetching country code", error);
    }
  };

  useEffect(() => {
    const prepaidBalance = userInfo?.prepaidBalance || 0;
    const postpaidBalance = userInfo?.postpaidBalance || 0;
    const isSufficientBalance = hasSufficientBalance(
      prepaidBalance,
      grandTotal
    );

    if (!isSufficientBalance) {
      setShowInsufficientModal(true);
      return;
    }
  }, []);

  const FlightDetail = () => {
    const [isExpanded, setIsExpanded] = useState(true); // <-- toggle state

    const handleToggle = () => {
      setIsExpanded((prev) => !prev);
    };

    return (
      <>
        {!!flightOutboundDataforRoundTrip && !!flightInboundDataforRoundTrip ? (
          <div className="card shadow-none">
            <div className="card-header card-head-bg">
              Flight Detail
              <div className=" pe-4 cursor-pointer" onClick={handleToggle}>
                {isExpanded ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </div>
            </div>

            {isExpanded && (
              <>
                <FlightDetailMainCard
                  flightData={
                    !isInternationalFlight
                      ? flightOutboundDataforRoundTrip
                      : flightRoundTripDataForInternationalOutBound
                  }
                  refundable={
                    location?.state?.outBoundData?.Fare?.PaxFares?.[0]
                      ?.Refundable
                  }
                  flightFareRules={location?.state?.outBoundData?.FareRule}
                  isInBound={false}
                  isInternationalFlight={isInternationalFlight}
                />
                <FlightDetailMainCard
                  flightData={
                    !isInternationalFlight
                      ? flightInboundDataforRoundTrip
                      : flightRoundTripDataForInternationalInBound
                  }
                  refundable={
                    location?.state?.inBoundData?.Fare?.PaxFares?.[0]
                      ?.Refundable
                  }
                  flightFareRules={location?.state?.inBoundData?.FareRule}
                  isInBound={true}
                  isInternationalFlight={isInternationalFlight}
                />
              </>
            )}
          </div>
        ) : (
          <div className="card shadow-none">
            <div className="card-header card-head-bg">
              Flight Details
              <div className=" pe-4 cursor-pointer" onClick={handleToggle}>
                {isExpanded ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </div>
            </div>
            {isExpanded && (
              <FlightDetailMainCard
                flightData={oneWayData}
                refundable={refundable}
                flightFareRules={fareRule}
                isInternationalFlight={isInternationalFlight}
              />
            )}
          </div>
        )}
      </>
    );
  };
  useEffect(() => {
    if (showNotifier) {
      const timer = setTimeout(() => setShowNotifier(false), 100);
      return () => clearTimeout(timer);
    }
  }, [showNotifier]);
  const handleContinueButton = () => {
    if (activeStep === 0) {
      if (!isCheckBoxChecked) {
        setShowNotifier(true);
      } else {
        formik.handleSubmit();
      }
    } else if (activeStep === 1) {
      if (!isCheckBoxChecked) {
        setShowNotifier(true);
      } else {
        setActiveStep(2);
      }
    }
  };

  const getStepContent = (step: number) => {
    switch (step) {
      case 0:
        return (
          <>
            <FlightDetail />

            {/* <FreeCancellationCard /> */}
            {/* Important Information-card */}
            {/* <div className="card mb-3 mt-3">
              <div className="card-body px-10 py-7.5 lg:pe-12.5">
                <div className="flex flex-wrap md:flex-nowrap items-center gap-6 md:gap-10">
                  <div className="flex flex-col gap-3">
                    <h2 className="text-1.5xl font-semibold text-gray-900">
                      Important Information
                    </h2>

                    <div className="row">
                      <div className="col-md-9 col-sm-12 col-xs-12">
                        <div className="text-sm text-gray-700 leading-5.5">
                          <ul>
                            <li className="ng-binding">
                              Please make sure that you have all relevant visa,
                              transit visa (if applicable), immigration
                              clearance and passport with a validity of minimum
                              6 months from the date of travel.
                            </li>
                            <li>
                              All visa rules on our website are just indicative
                              & are updated with best of our efforts. Please
                              refer official website of the respective country
                              to explore the complete and accurate requirements.
                              EaseMyTrip will not be liable for any claims about
                              non-travel because of the lack of any document
                            </li>
                            <li>For more visa details visit here</li>
                          </ul>
                        </div>
                      </div>

                      <div className="col-3">
                        <img
                          alt="image"
                          className="dark:hidden max-h-[180px]"
                          src="media/illustrations/place-flying-sunset-sky.png"
                        />
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div> */}
            {/* <TravelInsuranceCard /> */}

            {/* ---------contact detail ----------------- */}
            {/* <div className="card card-custom my-3">
              <div className="card-header card-head-bg">Contact Details</div>

              <div className="card-body">
                <div className="row">
                  <div className="col-md-2">
                    <MuiSearchSelect
                      placeholder="Enter Country Code"
                      onChange={(value) => {
                        formik.setFieldValue("countryCode", value);
                      }}
                      options={countryCode}
                      label="Country Code"
                      value={formik.values.countryCode}
                      isRequired={true}
                      errorText={
                        formik.touched.countryCode && formik.errors.countryCode
                          ? formik.errors.countryCode
                          : ""
                      }
                      isInvalid={
                        formik.touched.countryCode &&
                        Boolean(formik.errors.countryCode)
                      }
                    />
                  </div>
                  <div className="col-md-5">
                    <MuiInput
                      placeholder="Mobile Number"
                      label={"Mobile Number"}
                      value={formik.values.mobileNum}
                      onChange={(val) => formik.setFieldValue("mobileNum", val)}
                      isRequired={true}
                      errorText={
                        formik.touched.mobileNum && formik.errors.mobileNum
                          ? formik.errors.mobileNum
                          : ""
                      }
                      isInvalid={
                        formik.touched.mobileNum &&
                        Boolean(formik.errors.mobileNum)
                      }
                      slotProps={{
                        htmlInput: {
                          maxLength: 10,
                        },
                      }}
                    />
                  </div>
                  <div className="col-md-5">
                    <MuiInput
                      placeholder="Email ID"
                      label={"Email ID"}
                      value={formik.values.email}
                      onChange={(val) => formik.setFieldValue("email", val)}
                      isRequired={true}
                      errorText={
                        formik.touched.email && formik.errors.email
                          ? formik.errors.email
                          : ""
                      }
                      isInvalid={
                        formik.touched.email && Boolean(formik.errors.email)
                      }
                    />
                  </div>
                </div>
              </div>
            </div> */}
            {/* ---------contact detail ----------------- */}
            <div className="card card-custom my-3">
              <div className="card-header card-head-bg">Traveller Details</div>
              {formik.values.adultTravellers?.map(
                (traveler: any, index: any) => (
                  <div className="card-body" key={`adult-traveler-${index}`}>
                    <div className="card">
                      <div className="card-header d-flex justify-content-between align-items-center">
                        <h3 className="">
                          {/* <Checkbox
                          className="mb-1"
                          checked={traveler.isSelected || false}
                          onChange={(e) => {
                            formik.setFieldValue(
                              `adultTravellers[${index}].isSelected`,
                              e.target.checked
                            );
                          }}
                        /> */}
                          Adult {index + 1}
                        </h3>
                        {/* <span
                          onClick={() => toggleTravellerActive(index)}
                          className="cursor-pointer"
                        >
                          {traveler.isActive ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </span> */}
                      </div>

                      {(traveler.isActive === undefined ||
                        traveler.isActive) && (
                        <div className="card-body">
                          <div className="row mt-4">
                            <div className="col-md-2 mb-3 mb-md-0">
                              <MuiSearchSelect
                                label="Title"
                                placeholder="Select Title"
                                options={titleList}
                                onChange={(value, id) => {
                                  formik.setFieldTouched(
                                    `adultTravellers[${index}].Title`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `adultTravellers[${index}].Title`,
                                    value
                                  );
                                }}
                                value={traveler.Title || ""}
                                isRequired={true}
                                isInvalid={
                                  formik.touched.adultTravellers?.[index]
                                    ?.Title &&
                                  (
                                    formik.errors.adultTravellers?.[
                                      index
                                    ] as any
                                  )?.Title
                                }
                                errorText={(
                                  formik.touched.adultTravellers?.[index]
                                    ?.Title &&
                                  (
                                    formik.errors.adultTravellers?.[
                                      index
                                    ] as any
                                  )?.Title
                                )?.toString()}
                              />
                            </div>
                            <div className="col-md-5 my-under-500">
                              <MuiInput
                                placeholder="First Name"
                                label="First Name & (Middle name, if any)"
                                value={traveler.FirstName || ""}
                                onChange={(e) => {
                                  formik.setFieldTouched(
                                    `adultTravellers[${index}].FirstName`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `adultTravellers[${index}].FirstName`,
                                    e
                                  );
                                }}
                                isInvalid={
                                  formik.touched.adultTravellers?.[index]
                                    ?.FirstName &&
                                  (
                                    formik.errors.adultTravellers?.[
                                      index
                                    ] as any
                                  )?.FirstName
                                }
                                errorText={(
                                  formik.touched.adultTravellers?.[index]
                                    ?.FirstName &&
                                  (
                                    formik.errors.adultTravellers?.[
                                      index
                                    ] as any
                                  )?.FirstName
                                )?.toString()}
                                isRequired={true}
                              />
                            </div>
                            <div className="col-md-5 mt-3 mt-md-0">
                              <MuiInput
                                placeholder="Last Name"
                                label="Last Name"
                                value={traveler.LastName || ""}
                                onChange={(e) => {
                                  formik.setFieldTouched(
                                    `adultTravellers[${index}].LastName`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `adultTravellers[${index}].LastName`,
                                    e
                                  );
                                }}
                                isRequired={true}
                                isInvalid={
                                  formik.touched.adultTravellers?.[index]
                                    ?.LastName &&
                                  (
                                    formik.errors.adultTravellers?.[
                                      index
                                    ] as any
                                  )?.LastName
                                }
                                errorText={(
                                  formik.touched.adultTravellers?.[index]
                                    ?.LastName &&
                                  (
                                    formik.errors.adultTravellers?.[
                                      index
                                    ] as any
                                  )?.LastName
                                )?.toString()}
                              />
                            </div>
                            <div className="col-md-3 mt-4">
                              <MuiInput
                                placeholder="Email"
                                label="Email Id"
                                value={traveler.EmailAddress || ""}
                                isRequired={true}
                                onChange={(e) => {
                                  formik.setFieldTouched(
                                    `adultTravellers[${index}].EmailAddress`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `adultTravellers[${index}].EmailAddress`,
                                    e
                                  );
                                }}
                                isInvalid={
                                  formik.touched.adultTravellers?.[index]
                                    ?.EmailAddress &&
                                  (
                                    formik.errors.adultTravellers?.[
                                      index
                                    ] as any
                                  )?.EmailAddress
                                }
                                errorText={(
                                  formik.touched.adultTravellers?.[index]
                                    ?.EmailAddress &&
                                  (
                                    formik.errors.adultTravellers?.[
                                      index
                                    ] as any
                                  )?.EmailAddress
                                )?.toString()}
                              />
                            </div>
                            <div className="col-md-3 mt-4">
                              {/* <MuiInput
                                label="Contact Number"
                                placeholder="Contact Number"
                                value={traveler.MobileNumber || ""}
                                isRequired={true}
                                onChange={(e) => {
                                  formik.setFieldTouched(
                                    `adultTravellers[${index}].MobileNumber`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `adultTravellers[${index}].MobileNumber`,
                                    e
                                  );
                                }}
                                isInvalid={
                                  formik.touched.adultTravellers?.[index]
                                    ?.MobileNumber &&
                                  (
                                    formik.errors.adultTravellers?.[
                                      index
                                    ] as any
                                  )?.MobileNumber
                                }
                                errorText={(
                                  formik.touched.adultTravellers?.[index]
                                    ?.MobileNumber &&
                                  (
                                    formik.errors.adultTravellers?.[
                                      index
                                    ] as any
                                  )?.MobileNumber
                                 )?.toString()}
                                 slotProps={{
                                  htmlInput: {
                                    maxLength: 10,
                                  },
                                }}
                              /> */}

                              <div className="form-group">
                                <PhoneInput
                                  value={traveler.MobileNumber}
                                  placeholder="Enter mobile number"
                                  onChange={(e) => {
                                    // formik.setFieldTouched(
                                    //   `adultTravellers[${index}].MobileNumber`,
                                    //   false
                                    // );
                                    const digitsOnly = e
                                      .replace(/\D/g, "")
                                      .slice(0, 15);
                                    formik.setFieldValue(
                                      `adultTravellers[${index}].MobileNumber`,
                                      digitsOnly
                                    );
                                  }}
                                  inputStyle={{
                                    width: "100%",
                                    borderColor:
                                      getIn(
                                        formik.touched,
                                        `adultTravellers[${index}].MobileNumber`
                                      ) &&
                                      getIn(
                                        formik.errors,
                                        `adultTravellers[${index}].MobileNumber`
                                      )
                                        ? "#d32f2f" // लाल बॉर्डर जब error हो
                                        : "#ccc", // नॉर्मल बॉर्डर
                                  }}
                                  preferredCountries={["ae", "in", "us"]}
                                  enableSearch
                                  inputProps={{
                                    name: `adultTravellers[${index}].MobileNumber`,
                                    required: true,
                                    onBlur: () =>
                                      formik.setFieldTouched(
                                        `adultTravellers[${index}].MobileNumber`,
                                        true
                                      ),
                                  }}
                                  isValid={(value: string) => {
                                    const mobileRegex = /^[0-9]{8,15}$/;
                                    const isValid = mobileRegex.test(
                                      value.replace(/^\+?\d{1,4}/, "")
                                    );
                                    return isValid || "";
                                  }}
                                />

                                {/* Manually render Formik error */}
                                {formik.touched.adultTravellers?.[index]
                                  ?.MobileNumber &&
                                  (
                                    formik.errors.adultTravellers?.[
                                      index
                                    ] as any
                                  )?.MobileNumber && (
                                    <div className="phone-error-msg">
                                      {
                                        (
                                          formik.errors.adultTravellers?.[
                                            index
                                          ] as any
                                        )?.MobileNumber
                                      }
                                    </div>
                                  )}
                              </div>
                            </div>
                            <div className="col-md-3 mt-4">
                              <MuiSearchSelect
                                label="Iss.Country"
                                placeholder={"Passport Issue Country"}
                                options={countryName}
                                onChange={(value, id) => {
                                  formik.setFieldTouched(
                                    `adultTravellers[${index}].countryName`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `adultTravellers[${index}].countryName`,
                                    value
                                  );
                                }}
                                value={traveler?.countryName}
                                isRequired={true}
                                isInvalid={
                                  formik.touched.adultTravellers?.[index]
                                    ?.countryName &&
                                  (
                                    formik.errors.adultTravellers?.[
                                      index
                                    ] as any
                                  )?.countryName
                                }
                                errorText={(
                                  formik.touched.adultTravellers?.[index]
                                    ?.countryName &&
                                  (
                                    formik.errors.adultTravellers?.[
                                      index
                                    ] as any
                                  )?.countryName
                                )?.toString()}
                              />
                            </div>
                            <div className="col-md-3 mt-4">
                              <MuiSearchSelect
                                label="Nationality"
                                placeholder={"Select Nationality"}
                                options={nationality}
                                onChange={(value, id) => {
                                  formik.setFieldTouched(
                                    `adultTravellers[${index}].nationality`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `adultTravellers[${index}].nationality`,
                                    value
                                  );
                                }}
                                value={traveler?.nationality}
                                isRequired={true}
                                isInvalid={
                                  formik.touched.adultTravellers?.[index]
                                    ?.nationality &&
                                  (
                                    formik.errors.adultTravellers?.[
                                      index
                                    ] as any
                                  )?.nationality
                                }
                                errorText={(
                                  formik.touched.adultTravellers?.[index]
                                    ?.nationality &&
                                  (
                                    formik.errors.adultTravellers?.[
                                      index
                                    ] as any
                                  )?.nationality
                                )?.toString()}
                              />
                            </div>
                          </div>

                          {isInternationalFlight && (
                            <div className="row">
                              <div
                                className="col-md-12 showmore Plu mt-2 mb-2"
                                onClick={() => togglePassportInfo(index)}
                              >
                                {traveler.showPassport ? "(-)" : "(+)"} Passport
                                Information
                              </div>

                              {traveler.showPassport && (
                                <div className="row mb-3">
                                  <div className="col-md-4  mb-4 mb-sm-0">
                                    <MuiDatePicker
                                      label="Date of Birth"
                                      value={
                                        !!traveler.DOB
                                          ? dayjs(traveler.DOB)
                                          : null
                                      }
                                      onChange={(date) => {
                                        formik.setFieldValue(
                                          `adultTravellers[${index}].DOB`,
                                          date
                                        );
                                      }}
                                      isError={
                                        formik.touched.adultTravellers?.[index]
                                          ?.DOB &&
                                        (
                                          formik.errors.adultTravellers?.[
                                            index
                                          ] as any
                                        )?.DOB
                                      }
                                      errorText={(
                                        formik.touched.adultTravellers?.[index]
                                          ?.DOB &&
                                        (
                                          formik.errors.adultTravellers?.[
                                            index
                                          ] as any
                                        )?.DOB
                                      )?.toString()}
                                      isDisablePastDate={false}
                                    />
                                  </div>
                                  <div className="col-md-4  mb-4 mb-sm-0">
                                    <MuiInput
                                      placeholder="Passport No"
                                      label="Passport No"
                                      value={traveler.PassportNo || ""}
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          `adultTravellers[${index}].PassportNo`,
                                          e
                                        );
                                      }}
                                      isRequired={true}
                                      isInvalid={
                                        formik.touched.adultTravellers?.[index]
                                          ?.PassportNo &&
                                        (
                                          formik.errors.adultTravellers?.[
                                            index
                                          ] as any
                                        )?.PassportNo
                                      }
                                      errorText={(
                                        formik.touched.adultTravellers?.[index]
                                          ?.PassportNo &&
                                        (
                                          formik.errors.adultTravellers?.[
                                            index
                                          ] as any
                                        )?.PassportNo
                                      )?.toString()}
                                    />
                                  </div>
                                  <div className="col-md-4">
                                    <MuiDatePicker
                                      label="Passport Expiry Date"
                                      value={
                                        traveler.PassportExpiryDate
                                          ? dayjs(traveler.PassportExpiryDate)
                                          : null
                                      }
                                      onChange={(date) => {
                                        formik.setFieldValue(
                                          `adultTravellers[${index}].PassportExpiryDate`,
                                          date
                                        );
                                      }}
                                      isError={
                                        formik.touched.adultTravellers?.[index]
                                          ?.PassportExpiryDate &&
                                        (
                                          formik.errors.adultTravellers?.[
                                            index
                                          ] as any
                                        )?.PassportExpiryDate
                                      }
                                      errorText={(
                                        formik.touched.adultTravellers?.[index]
                                          ?.PassportExpiryDate &&
                                        (
                                          formik.errors.adultTravellers?.[
                                            index
                                          ] as any
                                        )?.PassportExpiryDate
                                      )?.toString()}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          )}

                          {/* <div className="row">
                          <div
                            className="col-md-12 showmore Plu pt-0 mb-2"
                            onClick={() => toggleMealPreference(index)}
                          >
                            {traveler.showMealPreference ? "(-)" : "(+)"}{" "}
                            Frequent flyer number and Meal preference (optional)
                          </div>

                          {traveler.showMealPreference && (
                            <div className="row">
                              <div className="col-md-4">
                                <MuiInput
                                  placeholder="Frequent flyer no."
                                  label="Frequent Flyer Number"
                                  value={traveler.FrequentFlierNumber || ""}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      `adultTravellers[${index}].FrequentFlierNumber`,
                                      e
                                    );
                                  }}
                                />
                              </div>
                              <div className="col-md-4">
                                <MuiInput
                                  placeholder="Enter Airline Name"
                                  label="Airline"
                                  value={traveler.Airline || ""}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      `adultTravellers[${index}].Airline`,
                                      e
                                    );
                                  }}
                                />
                              </div>
                              <div className="col-md-4">
                                <MuiSearchSelect
                                  placeholder="Meal Preference"
                                  options={[]}
                                  onChange={(value, id) => {
                                    formik.setFieldValue(
                                      `adultTravellers[${index}].MealPreference`,
                                      value
                                    );
                                  }}
                                  value={traveler.MealPreference || ""}
                                  label="Meal Preference"
                                />
                              </div>
                            </div>
                          )}
                        </div> */}
                        </div>
                      )}
                    </div>

                    {index === formik.values.adultTravellers.length - 1 &&
                      formik.values.adultTravellers?.length !==
                        location?.state.travellersDetail?.adultCount && (
                        <div
                          className="col-md-12 showmore Plu mt-2 mb-2"
                          onClick={addAdultTraveller}
                        >
                          (+) Add Adult
                        </div>
                      )}

                    {formik.values.adultTravellers.length > 1 && (
                      <div
                        className="col-md-12 showmore Plu mt-2 mb-2 text-danger"
                        onClick={() => removeAdultTraveller(index)}
                      >
                        (-) Remove
                      </div>
                    )}
                  </div>
                )
              )}
              {location.state?.travellersDetail?.childrenCount !== 0 &&
                formik.values.ChildTraveller?.map(
                  (traveler: any, index: any) => (
                    <div className="card-body" key={`child-traveler-${index}`}>
                      <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                          <h3 className="">
                            {/* <Checkbox
                          className="mb-1"
                          checked={traveler.isSelected || false}
                          onChange={(e) => {
                            formik.setFieldValue(
                              `adultTravellers[${index}].isSelected`,
                              e.target.checked
                            );
                          }}
                        /> */}
                            Child {index + 1}
                          </h3>
                          <span
                            onClick={() => toggleTravellerActiveForChild(index)}
                            className="cursor-pointer"
                          >
                            {traveler.isActive ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}
                          </span>
                        </div>

                        {(traveler.isActive === undefined ||
                          traveler.isActive) && (
                          <div className="card-body">
                            <div className="row mt-4">
                              <div className="col-md-2">
                                <MuiSearchSelect
                                  placeholder="Select Title"
                                  options={childrenTitle}
                                  label="Title"
                                  onChange={(value, id) => {
                                    formik.setFieldTouched(
                                      `ChildTraveller[${index}].nationality`,
                                      false
                                    );
                                    formik.setFieldValue(
                                      `ChildTraveller[${index}].Title`,
                                      value
                                    );
                                  }}
                                  value={traveler.Title || ""}
                                  isRequired={true}
                                  isInvalid={
                                    formik.touched.ChildTraveller?.[index]
                                      ?.Title &&
                                    (
                                      formik.errors.ChildTraveller?.[
                                        index
                                      ] as any
                                    )?.Title
                                  }
                                  errorText={(
                                    formik.touched.ChildTraveller?.[index]
                                      ?.Title &&
                                    (
                                      formik.errors.ChildTraveller?.[
                                        index
                                      ] as any
                                    )?.Title
                                  )?.toString()}
                                />
                              </div>
                              <div className="col-md-5">
                                <MuiInput
                                  placeholder="First Name"
                                  label="First Name & (Middle name, if any)"
                                  value={traveler.FirstName || ""}
                                  onChange={(e) => {
                                    formik.setFieldTouched(
                                      `ChildTraveller[${index}].FirstName`,
                                      false
                                    );
                                    formik.setFieldValue(
                                      `ChildTraveller[${index}].FirstName`,
                                      e
                                    );
                                  }}
                                  isRequired={true}
                                  isInvalid={
                                    formik.touched.ChildTraveller?.[index]
                                      ?.FirstName &&
                                    (
                                      formik.errors.ChildTraveller?.[
                                        index
                                      ] as any
                                    )?.FirstName
                                  }
                                  errorText={(
                                    formik.touched.ChildTraveller?.[index]
                                      ?.FirstName &&
                                    (
                                      formik.errors.ChildTraveller?.[
                                        index
                                      ] as any
                                    )?.FirstName
                                  )?.toString()}
                                />
                              </div>
                              <div className="col-md-5">
                                <MuiInput
                                  placeholder="Last Name"
                                  label="Last Name"
                                  value={traveler.LastName || ""}
                                  onChange={(e) => {
                                    formik.setFieldTouched(
                                      `ChildTraveller[${index}].LastName`,
                                      false
                                    );
                                    formik.setFieldValue(
                                      `ChildTraveller[${index}].LastName`,
                                      e
                                    );
                                  }}
                                  isRequired={true}
                                  isInvalid={
                                    formik.touched.ChildTraveller?.[index]
                                      ?.LastName &&
                                    (
                                      formik.errors.ChildTraveller?.[
                                        index
                                      ] as any
                                    )?.LastName
                                  }
                                  errorText={(
                                    formik.touched.ChildTraveller?.[index]
                                      ?.LastName &&
                                    (
                                      formik.errors.ChildTraveller?.[
                                        index
                                      ] as any
                                    )?.LastName
                                  )?.toString()}
                                />
                              </div>
                            </div>

                            {/* <div className="row">
                          <div
                            className="col-md-12 showmore Plu pt-0 mb-2"
                            onClick={() => toggleMealPreference(index)}
                          >
                            {traveler.showMealPreference ? "(-)" : "(+)"}{" "}
                            Frequent flyer number and Meal preference (optional)
                          </div>

                          {traveler.showMealPreference && (
                            <div className="row">
                              <div className="col-md-4">
                                <MuiInput
                                  placeholder="Frequent flyer no."
                                  label="Frequent Flyer Number"
                                  value={traveler.FrequentFlierNumber || ""}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      `adultTravellers[${index}].FrequentFlierNumber`,
                                      e
                                    );
                                  }}
                                />
                              </div>
                              <div className="col-md-4">
                                <MuiInput
                                  placeholder="Enter Airline Name"
                                  label="Airline"
                                  value={traveler.Airline || ""}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      `adultTravellers[${index}].Airline`,
                                      e
                                    );
                                  }}
                                />
                              </div>
                              <div className="col-md-4">
                                <MuiSearchSelect
                                  placeholder="Meal Preference"
                                  options={[]}
                                  onChange={(value, id) => {
                                    formik.setFieldValue(
                                      `adultTravellers[${index}].MealPreference`,
                                      value
                                    );
                                  }}
                                  value={traveler.MealPreference || ""}
                                  label="Meal Preference"
                                />
                              </div>
                            </div>
                          )}
                        </div> */}

                            {isInternationalFlight && (
                              <div className="row">
                                <div
                                  className="col-md-12 showmore Plu mt-2 mb-2"
                                  onClick={() =>
                                    togglePassportInfoForChild(index)
                                  }
                                >
                                  {traveler.showPassport ? "(-)" : "(+)"}
                                  Passport Information
                                </div>

                                {traveler.showPassport && (
                                  <div className="row mb-3">
                                    <div className="col-md-4  mb-4 mb-sm-0">
                                      <MuiDatePicker
                                        label="Date of Birth"
                                        value={
                                          !!traveler.DOB
                                            ? dayjs(traveler.DOB)
                                            : null
                                        }
                                        onChange={(date) => {
                                          formik.setFieldValue(
                                            `ChildTraveller[${index}].DOB`,
                                            date
                                          );
                                        }}
                                        isError={
                                          formik.touched.ChildTraveller?.[index]
                                            ?.DOB &&
                                          (
                                            formik.errors.ChildTraveller?.[
                                              index
                                            ] as any
                                          )?.DOB
                                        }
                                        errorText={(
                                          formik.touched.ChildTraveller?.[index]
                                            ?.DOB &&
                                          (
                                            formik.errors.ChildTraveller?.[
                                              index
                                            ] as any
                                          )?.DOB
                                        )?.toString()}
                                        isDisablePastDate={false}
                                      />
                                    </div>
                                    <div className="col-md-4  mb-4 mb-sm-0">
                                      <MuiInput
                                        placeholder="Passport No"
                                        label="Passport No"
                                        value={traveler.PassportNo || ""}
                                        onChange={(e) => {
                                          formik.setFieldValue(
                                            `ChildTraveller[${index}].PassportNo`,
                                            e
                                          );
                                        }}
                                        isRequired={true}
                                        isInvalid={
                                          formik.touched.ChildTraveller?.[index]
                                            ?.PassportNo &&
                                          (
                                            formik.errors.ChildTraveller?.[
                                              index
                                            ] as any
                                          )?.PassportNo
                                        }
                                        errorText={(
                                          formik.touched.ChildTraveller?.[index]
                                            ?.PassportNo &&
                                          (
                                            formik.errors.ChildTraveller?.[
                                              index
                                            ] as any
                                          )?.PassportNo
                                        )?.toString()}
                                      />
                                    </div>
                                    <div className="col-md-4">
                                      <MuiDatePicker
                                        label="Passport Expiry Date"
                                        value={
                                          traveler.PassportExpiryDate
                                            ? dayjs(traveler.PassportExpiryDate)
                                            : null
                                        }
                                        onChange={(date) => {
                                          formik.setFieldValue(
                                            `ChildTraveller[${index}].PassportExpiryDate`,
                                            date
                                          );
                                        }}
                                        isError={
                                          formik.touched.ChildTraveller?.[index]
                                            ?.PassportExpiryDate &&
                                          (
                                            formik.errors.ChildTraveller?.[
                                              index
                                            ] as any
                                          )?.PassportExpiryDate
                                        }
                                        errorText={(
                                          formik.touched.ChildTraveller?.[index]
                                            ?.PassportExpiryDate &&
                                          (
                                            formik.errors.ChildTraveller?.[
                                              index
                                            ] as any
                                          )?.PassportExpiryDate
                                        )?.toString()}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      {index === formik.values.ChildTraveller.length - 1 &&
                        formik.values.ChildTraveller?.length !==
                          location?.state.travellersDetail?.childrenCount && (
                          <div
                            className="col-md-12 showmore Plu mt-2 mb-2"
                            onClick={addChildTraveller}
                          >
                            (+) Add Child
                          </div>
                        )}

                      {formik.values.ChildTraveller.length > 1 && (
                        <div
                          className="col-md-12 showmore Plu mt-2 mb-2 text-danger"
                          onClick={() => removeChildTraveller(index)}
                        >
                          (-) Remove
                        </div>
                      )}
                    </div>
                  )
                )}
              {location.state?.travellersDetail?.infantCount !== 0 &&
                formik.values.InfantTraveller?.map(
                  (traveler: any, index: any) => (
                    <div className="card-body" key={`infant-traveler-${index}`}>
                      <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                          <h3 className="">
                            {/* <Checkbox
                          className="mb-1"
                          checked={traveler.isSelected || false}
                          onChange={(e) => {
                            formik.setFieldValue(
                              `adultTravellers[${index}].isSelected`,
                              e.target.checked
                            );
                          }}
                        /> */}
                            Infant {index + 1}
                          </h3>
                          <span
                            onClick={() =>
                              toggleTravellerActiveForInfant(index)
                            }
                            className="cursor-pointer"
                          >
                            {traveler.isActive ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}
                          </span>
                        </div>

                        {(traveler.isActive === undefined ||
                          traveler.isActive) && (
                          <div className="card-body">
                            <div className="row mt-4">
                              <div className="col-md-2">
                                <MuiSearchSelect
                                  placeholder="Select Title"
                                  options={childrenTitle}
                                  onChange={(value, id) => {
                                    formik.setFieldTouched(
                                      `InfantTraveller[${index}].Title`,
                                      false
                                    );
                                    formik.setFieldValue(
                                      `InfantTraveller[${index}].Title`,
                                      value
                                    );
                                  }}
                                  label="Title"
                                  value={traveler.Title || ""}
                                  isRequired={true}
                                  isInvalid={
                                    formik.touched.InfantTraveller?.[index]
                                      ?.Title &&
                                    (
                                      formik.errors.InfantTraveller?.[
                                        index
                                      ] as any
                                    )?.Title
                                  }
                                  errorText={(
                                    formik.touched.InfantTraveller?.[index]
                                      ?.Title &&
                                    (
                                      formik.errors.InfantTraveller?.[
                                        index
                                      ] as any
                                    )?.Title
                                  )?.toString()}
                                />
                              </div>
                              <div className="col-md-5">
                                <MuiInput
                                  placeholder="First Name"
                                  label="First Name & (Middle name, if any)"
                                  value={traveler.FirstName || ""}
                                  onChange={(e) => {
                                    formik.setFieldTouched(
                                      `InfantTraveller[${index}].FirstName`,
                                      false
                                    );
                                    formik.setFieldValue(
                                      `InfantTraveller[${index}].FirstName`,
                                      e
                                    );
                                  }}
                                  isRequired={true}
                                  isInvalid={
                                    formik.touched.InfantTraveller?.[index]
                                      ?.FirstName &&
                                    (
                                      formik.errors.InfantTraveller?.[
                                        index
                                      ] as any
                                    )?.FirstName
                                  }
                                  errorText={(
                                    formik.touched.InfantTraveller?.[index]
                                      ?.FirstName &&
                                    (
                                      formik.errors.InfantTraveller?.[
                                        index
                                      ] as any
                                    )?.FirstName
                                  )?.toString()}
                                />
                              </div>
                              <div className="col-md-5">
                                <MuiInput
                                  placeholder="Last Name"
                                  label="Last Name"
                                  value={traveler.LastName || ""}
                                  onChange={(e) => {
                                    formik.setFieldTouched(
                                      `InfantTraveller[${index}].LastName`,
                                      false
                                    );
                                    formik.setFieldValue(
                                      `InfantTraveller[${index}].LastName`,
                                      e
                                    );
                                  }}
                                  isRequired={true}
                                  isInvalid={
                                    formik.touched.InfantTraveller?.[index]
                                      ?.LastName &&
                                    (
                                      formik.errors.InfantTraveller?.[
                                        index
                                      ] as any
                                    )?.LastName
                                  }
                                  errorText={(
                                    formik.touched.InfantTraveller?.[index]
                                      ?.LastName &&
                                    (
                                      formik.errors.InfantTraveller?.[
                                        index
                                      ] as any
                                    )?.LastName
                                  )?.toString()}
                                />
                              </div>
                            </div>
                            <div className="row mt-4">
                              <div className="col-md-4">
                                <MuiDatePicker
                                  label="Date of Birth"
                                  value={
                                    !!traveler.DOB ? dayjs(traveler.DOB) : null
                                  }
                                  onChange={(date) => {
                                    formik.setFieldValue(
                                      `InfantTraveller[${index}].DOB`,
                                      date
                                    );
                                  }}
                                  isError={
                                    formik.touched.InfantTraveller?.[index]
                                      ?.DOB &&
                                    (
                                      formik.errors.InfantTraveller?.[
                                        index
                                      ] as any
                                    )?.DOB
                                  }
                                  errorText={(
                                    formik.touched.InfantTraveller?.[index]
                                      ?.DOB &&
                                    (
                                      formik.errors.InfantTraveller?.[
                                        index
                                      ] as any
                                    )?.DOB
                                  )?.toString()}
                                  isDisablePastDate={false}
                                />
                              </div>
                            </div>

                            {/* <div className="row">
                          <div
                            className="col-md-12 showmore Plu pt-0 mb-2"
                            onClick={() => toggleMealPreference(index)}
                          >
                            {traveler.showMealPreference ? "(-)" : "(+)"}{" "}
                            Frequent flyer number and Meal preference (optional)
                          </div>

                          {traveler.showMealPreference && (
                            <div className="row">
                              <div className="col-md-4">
                                <MuiInput
                                  placeholder="Frequent flyer no."
                                  label="Frequent Flyer Number"
                                  value={traveler.FrequentFlierNumber || ""}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      `adultTravellers[${index}].FrequentFlierNumber`,
                                      e
                                    );
                                  }}
                                />
                              </div>
                              <div className="col-md-4">
                                <MuiInput
                                  placeholder="Enter Airline Name"
                                  label="Airline"
                                  value={traveler.Airline || ""}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      `adultTravellers[${index}].Airline`,
                                      e
                                    );
                                  }}
                                />
                              </div>
                              <div className="col-md-4">
                                <MuiSearchSelect
                                  placeholder="Meal Preference"
                                  options={[]}
                                  onChange={(value, id) => {
                                    formik.setFieldValue(
                                      `adultTravellers[${index}].MealPreference`,
                                      value
                                    );
                                  }}
                                  value={traveler.MealPreference || ""}
                                  label="Meal Preference"
                                />
                              </div>
                            </div>
                          )}
                        </div> */}
                            {isInternationalFlight && (
                              <div className="row">
                                <div
                                  className="col-md-12 showmore Plu mt-2 mb-2"
                                  onClick={() =>
                                    togglePassportInfoForInfant(index)
                                  }
                                >
                                  {traveler.showPassport ? "(-)" : "(+)"}{" "}
                                  Passport Information
                                </div>

                                {traveler.showPassport && (
                                  <div className="row mb-3">
                                    <div className="col-md-4  mb-4 mb-sm-0">
                                      <MuiInput
                                        placeholder="Passport No"
                                        label="Passport No"
                                        value={traveler.PassportNo || ""}
                                        onChange={(e) => {
                                          formik.setFieldValue(
                                            `InfantTraveller[${index}].PassportNo`,
                                            e
                                          );
                                        }}
                                        isRequired={true}
                                        isInvalid={
                                          formik.touched.InfantTraveller?.[
                                            index
                                          ]?.PassportNo &&
                                          (
                                            formik.errors.InfantTraveller?.[
                                              index
                                            ] as any
                                          )?.PassportNo
                                        }
                                        errorText={(
                                          formik.touched.InfantTraveller?.[
                                            index
                                          ]?.PassportNo &&
                                          (
                                            formik.errors.InfantTraveller?.[
                                              index
                                            ] as any
                                          )?.PassportNo
                                        )?.toString()}
                                      />
                                    </div>
                                    <div className="col-md-4  mb-4 mb-sm-0">
                                      <MuiDatePicker
                                        label="Passport Expiry Date"
                                        value={
                                          traveler.PassportExpiryDate
                                            ? dayjs(traveler.PassportExpiryDate)
                                            : null
                                        }
                                        onChange={(date) => {
                                          formik.setFieldValue(
                                            `InfantTraveller[${index}].PassportExpiryDate`,
                                            date
                                          );
                                        }}
                                        isError={
                                          formik.touched.InfantTraveller?.[
                                            index
                                          ]?.PassportExpiryDate &&
                                          (
                                            formik.errors.InfantTraveller?.[
                                              index
                                            ] as any
                                          )?.PassportExpiryDate
                                        }
                                        errorText={(
                                          formik.touched.InfantTraveller?.[
                                            index
                                          ]?.PassportExpiryDate &&
                                          (
                                            formik.errors.InfantTraveller?.[
                                              index
                                            ] as any
                                          )?.PassportExpiryDate
                                        )?.toString()}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      {index === formik.values.InfantTraveller.length - 1 &&
                        formik.values.InfantTraveller?.length !==
                          location?.state.travellersDetail?.infantCount &&
                        location?.state.travellersDetail?.infantCount > 0 && (
                          <div
                            className="col-md-12 showmore Plu mt-2 mb-2"
                            onClick={addInfantTraveller}
                          >
                            (+) Add Infant
                          </div>
                        )}

                      {formik.values.InfantTraveller.length > 1 && (
                        <div
                          className="col-md-12 showmore Plu mt-2 mb-2 text-danger"
                          onClick={() => removeInfantTraveller(index)}
                        >
                          (-) Remove
                        </div>
                      )}
                    </div>
                  )
                )}
            </div>
          </>
        );
      case 1:
        return (
          <>
            <FlightDetail />
            {/* <TravellerDetailsCard/> */}
            <FlightSeatInfo
              isSeatMapLoading={isSeatMapLoading}
              seatMapData={seatMapData || []}
              meal={meals}
              baggage={baggage}
              totalTravellers={
                travellersDetail?.adultCount + travellersDetail?.childrenCount
              }
              otherCharges={(value: any) => {
                setOtherCharges(value);
                const selectedSeat = value?.selectedSeats;
                const selectedMeal = value?.selectedMeal;
                const selectedBaggage = value?.selectedBaggage;
                const outBound = location?.state?.outBoundData
                  ? Array.isArray(location.state.outBoundData)
                    ? location.state.outBoundData
                    : [location.state.outBoundData]
                  : [];

                const inBound = location?.state?.inBoundData
                  ? Array.isArray(location.state.inBoundData)
                    ? location.state.inBoundData
                    : [location.state.inBoundData]
                  : [];
                const flightSegement = isInternationalFlight
                  ? [...outBound, ...inBound]
                  : [location.state?.outBoundData];
                const ssrDetail = createSSRDetails({
                  selectedMeal,
                  selectedBaggage,
                  selectedSeats: selectedSeat,
                  flightSegments: flightSegement,
                });
                // setSelectedSSR((val) => [
                //   {
                //     ...val?.[0],
                //     SSRDetails: ssrDetail?.SSRDetails,
                //   },
                // ]);
                setSelectedSSR(ssrDetail?.SSRDetails);
              }}
              journeys={addonJourneys} // set this as all journeys from addon API response
              activeJourneyIndex={(index) => {
                setActiveJourneyIndex(index);
              }}
              selectedSeatsByJourney={selectedSeatsByJourney}
              setSelectedSeatsByJourney={setSelectedSeatsByJourney}
              isIntl={isInternationalFlight}
            />

            {/* GST-card */}
            {/* <div className="card my-2">
              <div className="card-body">
                <h3 className="">
                  <Checkbox
                    {...label}
                    defaultChecked
                    onClick={() => setGstBookIsActive(!gstBookIsActive)}
                  />{" "}
                  Use GST for this booking (Optional)
                </h3>
                <span>
                  To claim credit of GST charged by airlines /EaseMyTrip,please
                  enter your company's GST number
                </span>

                {gstBookIsActive && (
                  <div className="row mt-4">
                    <div className="col-md-3">
                      <MuiInput label={"E-mail"} placeholder="E-mail" />
                    </div>

                    <div className="col-md-3">
                      <MuiInput label={"Mobile"} placeholder="Mobile" />
                    </div>

                    <div className="col-md-3">
                      <MuiInput label={"GST no"} placeholder="GST no" />
                    </div>

                    <div className="col-md-3">
                      <MuiInput
                        label={"Company Name"}
                        placeholder="Company Name"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div> */}
          </>
        );
      case 2:
        return (
          <>
            {/* Traveller Details-card */}
            <FlightDetail />
            <div className="card mt-3">
              <div className="card-header card-head-bg">Traveller Details</div>

              <div className="card-body">
                <div style={{ overflowX: "auto", width: "100%" }}>
                  <table className="table text-end">
                    <thead>
                      <tr>
                        <th className="text-center min-w-[100px] !text-gray-700">
                          E-mail
                        </th>
                        <th className="text-center min-w-[100px] !text-gray-700">
                          Contact No.
                        </th>
                        <th className="text-center min-w-[100px]">
                          Adult{` (${formik.values.adultTravellers?.length})`}
                        </th>
                        <th className="text-center min-w-[100px] !text-gray-700">
                          Child{" "}
                          {` (${
                            formik.values.ChildTraveller?.[0]?.Title !== ""
                              ? formik.values.ChildTraveller?.length
                              : 0
                          })`}
                        </th>
                        <th className="text-center min-w-[100px]">
                          Infant{" "}
                          {` (${
                            formik.values.InfantTraveller?.[0]?.DOB !== ""
                              ? formik.values.InfantTraveller?.length
                              : 0
                          })`}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {/* Adult Email */}
                        <td className="text-center">
                          {formik.values.adultTravellers?.map(
                            (i: any, index: number) => (
                              <div key={`${i.EmailAddress}-${index}`}>
                                {i.EmailAddress}
                              </div>
                            )
                          )}
                        </td>

                        {/* Adult Mobile Number */}
                        <td className="text-center">
                          {formik.values.adultTravellers?.map(
                            (i: any, index: number) => (
                              <div key={`${i.MobileNumber}-${index}`}>
                                {i.MobileNumber}
                              </div>
                            )
                          )}
                        </td>

                        {/* Adult Full Name */}
                        <td className="text-center">
                          {formik.values.adultTravellers?.map(
                            (traveller: any, index: number) => (
                              <div key={`adult-${index}`}>
                                {traveller.FirstName} {traveller.LastName}
                              </div>
                            )
                          )}
                        </td>

                        {/* Child Full Name */}
                        <td className="text-center">
                          {formik.values.ChildTraveller?.map(
                            (traveller: any, index: number) => (
                              <div key={`child-${index}`}>
                                {traveller.FirstName} {traveller.LastName}
                              </div>
                            )
                          )}
                        </td>

                        {/* Infant Full Name */}
                        <td className="text-center">
                          {formik.values.InfantTraveller?.map(
                            (traveller: any, index: number) => (
                              <div key={`infant-${index}`}>
                                {traveller.FirstName} {traveller.LastName}
                              </div>
                            )
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* <PaymentCard /> */}
          </>
        );
      default:
        return "Unknown step";
    }
  };
  const formatTraveller = (travellers: any) =>
    travellers.map((traveller: any) => ({
      LastName: traveller.LastName || "",
      Title: traveller.Title || "",
      MiddleName: traveller.MiddleName || "",
      Gender: traveller.Gender || 1,
      EmailAddress: traveller.EmailAddress || "",
      FrequentFlierNumber: traveller.FrequentFlierNumber || "",
      FirstName: traveller.FirstName || "",
      PassportExpiryDate: traveller.PassportExpiryDate || "",
      PassportNo: traveller.PassportNo || "",
      MobileNumber: traveller.MobileNumber || "",
      Nationality: traveller.nationality || "",
    }));
  const travellerPayload: any = {
    AdultTraveller: formatTraveller(formik.values.adultTravellers),
  };

  if (
    formik.values.ChildTraveller?.[0]?.Title !== "" &&
    formik.values.ChildTraveller &&
    formik.values.ChildTraveller.length > 0
  ) {
    travellerPayload.ChildTraveller = formatTraveller(
      formik.values.ChildTraveller
    );
  }

  if (
    formik.values.InfantTraveller?.[0]?.DOB !== "" &&
    formik.values.InfantTraveller &&
    formik.values.InfantTraveller.length > 0
  ) {
    travellerPayload.InfantTraveller = formatTraveller(
      formik.values.InfantTraveller
    );
  }
  const handleBooking = async () => {
    try {
      const bookingSegment = localStorage.getItem("bookingSegment");
      let parsedAddonJourneys: any[] = [];

      if (bookingSegment) {
        parsedAddonJourneys = JSON.parse(bookingSegment);
        setAddonJourneys(parsedAddonJourneys);
        console.log("bookingSegment (parsed)", parsedAddonJourneys);
      }

      // common payload
      const commonPayload = {
        EngineID: 1,
        PaymentDetails: {
          BookingAmount: grandTotal,
        },
        Cabin: location?.state?.cabin,
        TraceId: traceId,
        Traveller: travellerPayload,
        TripType: !!location?.state?.outBoundData ? 0 : 1,
      };

      // one way
      const payloadForOneWay = {
        ...commonPayload,
        BookSegment: injectSSRDetailsIntoSegments(
          parsedAddonJourneys?.[0]?.Segments,
          selectedSSR
        ),
        FlightSearchDetails: [
          {
            BeginDate: formatDate(
              location?.state?.outBoundData?.Bonds?.[0]?.Legs?.[0]
                ?.DepartureDate
            ),
            Origin:
              location?.state?.outBoundData?.Bonds?.[0]?.Legs?.[0]?.Origin,
            Destination:
              location?.state?.outBoundData?.Bonds?.[0]?.Legs?.[0]?.Destination,
          },
        ],
      };

      // round trip
      const payloadRT = {
        ...commonPayload,
        BookSegment: [
          injectSSRDetailsIntoSegments(
            parsedAddonJourneys?.[0]?.Segments,
            selectedSSR
          )?.[0],
          injectSSRDetailsIntoSegments(
            parsedAddonJourneys?.[1]?.Segments,
            selectedSSR
          )?.[0],
        ],
        FlightSearchDetails: [
          {
            BeginDate: formatDate(
              location?.state?.outBoundData?.Bonds?.[0]?.Legs?.[0]
                ?.DepartureDate
            ),
            Origin:
              location?.state?.outBoundData?.Bonds?.[0]?.Legs?.[0]?.Origin,
            Destination:
              location?.state?.inBoundData?.Bonds?.[0]?.Legs?.[0]?.Origin,
          },
          {
            BeginDate: formatDate(
              location?.state?.inBoundData?.Bonds?.[0]?.Legs?.[0]?.DepartureDate
            ),
            Origin: location?.state?.inBoundData?.Bonds?.[0]?.Legs?.[0]?.Origin,
            Destination:
              location?.state?.outBoundData?.Bonds?.[0]?.Legs?.[0]?.Origin,
          },
        ],
      };

      // international one way
      const payloadINTL = {
        ...commonPayload,
        BookSegment: parsedAddonJourneys?.[0]?.Segments,
        FlightSearchDetails: [
          {
            BeginDate: formatDate(
              location?.state?.outBoundData?.Bonds?.[0]?.Legs?.[0]
                ?.DepartureDate
            ),
            Origin:
              location?.state?.outBoundData?.Bonds?.[0]?.Legs?.[0]?.Origin,
            Destination:
              location?.state?.outBoundData?.Bonds?.[0]?.Legs?.[0]?.Destination,
          },
        ],
      };

      // international round trip
      const payloadINTLRT = {
        ...commonPayload,
        BookSegment: [
          {
            ...parsedAddonJourneys?.[0]?.Segments?.[0],
            Bonds: [
              location?.state?.outBoundData?.Bonds?.[0],
              location?.state?.outBoundData?.Bonds?.[1],
            ],
            SSRDetails: [
              injectSSRDetails(
                location?.state?.outBoundData?.Bonds?.[0],
                selectedSSR
              ),
              injectSSRDetails(
                location?.state?.outBoundData?.Bonds?.[1],
                selectedSSR
              ),
            ],
          },
        ],
        FlightSearchDetails: [
          {
            BeginDate: formatDate(
              location?.state?.outBoundData?.Bonds?.[0]?.Legs?.[0]
                ?.DepartureDate
            ),
            Origin:
              location?.state?.outBoundData?.Bonds?.[0]?.Legs?.[0]?.Origin,
            Destination:
              location?.state?.outBoundData?.Bonds?.[0]?.Legs?.[0]?.Destination,
          },
          {
            BeginDate: formatDate(
              location?.state?.outBoundData?.Bonds?.[1]?.Legs?.[0]
                ?.DepartureDate
            ),
            Origin:
              location?.state?.outBoundData?.Bonds?.[1]?.Legs?.[0]?.Origin,
            Destination:
              location?.state?.outBoundData?.Bonds?.[1]?.Legs?.[0]?.Destination,
          },
        ],
      };

      // final payload select
      const payload = !!location.state?.inBoundData
        ? payloadRT
        : payloadForOneWay;

      const intlPayload =
        !!location.state?.inBoundData && !!location.state?.outBoundData
          ? payloadINTLRT
          : payloadINTL;

      const mainPayload = !isInternationalFlight ? payload : intlPayload;

      // API call
      const response = await FlightServices.flightBooking(mainPayload);

      if (response?.data?.Errors === null) {
        const payload = {
          ...response,
          booking_data: {
            bookingRes: {
              ...response?.data,
              TransactionId:
                response?.data?.TransactionId + generateRandomInteger(),
            },
            travellersDetail: mainPayload?.Traveller,
            bond: mainPayload?.BookSegment?.map((i: any) => i?.Bonds?.[0]),
            FareRule: location?.state?.outBoundData?.FareRule,
            fareRuleForRT: location?.state?.inBoundData?.FareRule,
          },
        };
        return payload;
      } else if (!!response?.data?.Errors) {
        showAlert({
          title: "Error",
          text: response?.data?.Errors?.Description || "Failed to fetch data",
          icon: "error",
        });
      }
    } catch (error: any) {
      showAlert({
        title: "Error",
        text: error?.message || "Failed to fetch data",
        icon: "error",
      });
      console.error("Error during booking:", error);
    }
  };

  const fetchBalance = async () => {
    try {
      const response = await UtilService.fetchBalance();
      if (response?.statusMsg === msgTypes?.SUCCESS?.msg) {
        // Assuming the response contains the balance data
        setUserInfo({
          ...userInfo,
          postpaidBalance: response.data?.postpaid || 0,
          prepaidBalance: response.data?.prepaid || 0,
        });
      } else {
        console.error("Failed to fetch balance data");
      }
    } catch (error) {}
  };
  const saveFlightBookingDetails = async (
    id: string,
    bookingType: string,
    paymentType: string,
    pgRes?: PGRes | null,
    bookingRes?: any | null
  ) => {
    // calculateCommission(grandTotal, {
    //   adultCount: travellersDetail?.adultCount,
    //   childrenCount: travellersDetail?.childrenCount,
    //   infantCount: travellersDetail?.infantCount,
    // },commissionValue ?? locatStorageCommissionValue) TODO:anjali

    const afterCommissionAmount = grandTotal + commissionAmount;
    const payload = {
      booking_txn_id: id,
      booking_type: bookingType,
      payment_type: paymentType,
      base_amount: grandTotal,
      commission_amount: commissionAmount,
      amount: afterCommissionAmount,
      ag_id: pgRes?.ag_id,
      ag_ref: pgRes?.ag_ref,
      country: pgRes?.country,
      currency: pgRes?.currency,
      me_id: pgRes?.me_id,
      order_number: pgRes?.order_number,
      status: pgRes?.status,
      transaction_date: pgRes?.transaction_date,
      transaction_time: pgRes?.transaction_time,
      couponCode: appliedCouponCode,
      discount_amount: ewtsOffer,
      rule_id: ruleId,
      booking_data: bookingRes,
    };

    const response = await UtilService.captureTransaction(payload);
    const creditLimitAvailable =
      Number(response?.postpaid_limit ?? 0) -
      Number(response?.postpaid_used ?? 0);
    const walletBalance =
      !!response?.wallet_balance && response?.wallet_balance
        ? Number(response.wallet_balance)
        : 0;
    const balance =
      userInfo?.user_type === CoorporateType.PRE_PAID
        ? walletBalance
        : creditLimitAvailable;
    if (!!response) {
      localStorage.removeItem("bookingSegment");
      localStorage.removeItem("travellerFormValues");

      Swal.fire({
        icon: "success",
        title: "Booking Confirmed!",
        text: `Your Flight has been successfully booked. Check your email for ticket details.`,
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6",
      }).then(() => {
        navigate("/flightbookingconfirmation", {
          state: {
            id: id,
            bookingRes: bookingRes,
            otherCharges: otherCharges,
          },
        }); // ✅ Replace with your actual route
      });
      fetchBalance();
      return true;
    } else {
      showAlert({
        title: "Error",
        text: "Something went wrong. Please try again.",
        icon: "error",
      });
      return false;
    }

    //need to check response and show alert accordingly
  };

  function separateSSRByType(ssrs: any[]) {
    const tempMeals: any[] = [];
    const tempBaggage: any[] = [];
    ssrs?.map((ssr) => {
      if (ssr.SSRType == "1") {
        tempMeals.push(ssr);
      } else if (ssr.SSRType == "2") {
        tempBaggage.push(ssr);
      }
    });

    setMeals(tempMeals);
    setBaggage(tempBaggage);
  }

  function handleStep(index: number) {
    if (isTravellerDetailFilled) setActiveStep(index);
  }

  const TermsAndCondition = () => (
    <div className="d-flex align-items-center">
      <Checkbox
        checked={isCheckBoxChecked} // ✅ use `checked`, not `value`
        onChange={(e) => setIsCheckBoxChecked(e.target.checked)} // ✅ proper change handling
      />
      <span className="pt-md-3">
        I understand & agree to the{" "}
        <Link to={"/termsandcondition"}>
          {" "}
          <span className="showmore">Terms and Conditions</span>.
        </Link>
      </span>
    </div>
  );
  return (
    <div>
      <>
        <div className="grow">
          <div className="sidemenu-show">
            <SideMenu />
          </div>
          <div className="wrapper flex grow flex-col">
            <Header />
          </div>
        </div>

        <main className="grow content" id="content" role="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-9 col-sm-12 ">
                <Box sx={{ width: "100%" }}>
                  <Stepper nonLinear activeStep={activeStep}>
                    {steps.map((label, index) => (
                      <Step key={label} completed={completed[index]}>
                        <StepButton
                          color="inherit"
                          onClick={() => handleStep(index)}
                        >
                          {label}
                        </StepButton>
                      </Step>
                    ))}
                  </Stepper>
                  <div>
                    {allStepsCompleted() ? (
                      <React.Fragment>
                        <Typography sx={{ mt: 2, mb: 1 }}>
                          All steps completed - you&apos;re finished
                        </Typography>
                        <Box
                          sx={{ display: "flex", flexDirection: "row", pt: 2 }}
                        >
                          <Box sx={{ flex: "1 1 auto" }} />
                          <Button onClick={handleReset}>Reset</Button>
                        </Box>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <Typography sx={{ mt: 2, mb: 1, py: 1 }}>
                          {getStepContent(activeStep)}
                        </Typography>
                        <Box
                          sx={{ display: "flex", flexDirection: "row", pt: 2 }}
                        >
                          {/* <Button
                          className="backstep-btn"
                            color="inherit"
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            sx={{ mr: 1 }}
                          >
                            Back
                          </Button> */}
                          <Box sx={{ flex: "1 1 auto" }} />
                          {/* <Button className="nextsteper-btn" onClick={handleNext} sx={{ mr: 1 }}>
                            Next
                          </Button> */}
                          {/* {activeStep !== steps.length &&
                            (completed[activeStep] ? (
                              <Typography
                                variant="caption"
                                sx={{ display: "inline-block" }}
                              >
                                Step {activeStep + 1} already completed
                              </Typography>
                            ) : (
                              <Button className="completesteper-btn" onClick={handleComplete}>
                                {completedSteps() === totalSteps() - 1
                                  ? "Finish "
                                  : "Complete Step "}
                              </Button>
                            ))} */}
                        </Box>
                      </React.Fragment>
                    )}
                  </div>
                </Box>
              </div>

              <div className="col-lg-3 col-sm-12 flight-margin-top-res">
                <div className="sticky-sidebar">
                  <FlightDetailPriceSummary
                    travellersDetail={travellersDetail}
                    otherCharges={otherCharges}
                    discountAmount={ewtsOffer}
                    commissionAmount={commissionAmount}
                  />
                  <FlightPromoCard
                    basePrice={grandTotal}
                    onApplyCoupon={handleCouponApply}
                    bookingFor="flight"
                    initialCouponCode={appliedCouponCode}
                    initialDiscount={ewtsOffer}
                  />
                  <PaymentModeCard
                    activeStep={activeStep}
                    createBooking={handleBooking}
                    grandTotal={grandTotal + commissionAmount}
                    saveFlightBookingDetails={saveFlightBookingDetails}
                    bookingFor="flight"
                    couponCode={appliedCouponCode}
                    flightSearchDetail={flightSearchDetail}
                    passengerDetail={travellersDetail}
                    termsAndCondition={<TermsAndCondition />}
                    isCheckBoxChecked={isCheckBoxChecked}
                    travellerDetail={travellerPayload}
                  />

                  {showNotifier && (
                    <Notifier
                      message="Please agree to the Terms & Conditions"
                      variant="error"
                    />
                  )}
                </div>
              </div>

              {activeStep !== 2 && (
                <div className="col-12 flight-continue-btn">
                  <div className="user-button">
                    <MuiButton
                      className=" main-btn"
                      label="Continue Booking"
                      type="submit"
                      // onClick={checkIsSeatAvailble}
                      onClick={handleContinueButton}
                    />
                  </div>
                </div>
              )}
            </div>
            {!!userInfo?.corporate_id && (
              <InsufficientBalanceModal
                open={showInsufficientModal}
                onClose={() => setShowInsufficientModal(false)}
              />
            )}
          </div>
        </main>
      </>
    </div>
  );
};

export default FlightDetail;
